export const TOKEN_COOKIE = 'beon_auth_token';
export const REFRESH_COOKIE = 'beon_refresh_token';
